//Obtain GCLID
const obtainGclid = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const gclid = urlParams.get('gclid')

    if (gclid) 
        localStorage.setItem('gclid', gclid);

}


// Función para obtener y almacenar el utm_source
const obtainUtmSource = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const utmSource = urlParams.get('utm_source')

    if (utmSource) 
        localStorage.setItem('utm_source', utmSource);
}

// Función para obtener y almacenar el utm_medium
const obtainUtmMedium = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const utmMedium = urlParams.get('utm_medium')

    if (utmMedium)
        localStorage.setItem('utm_medium', utmMedium);
}

// Función para obtener y almacenar el utm_campaign
const obtainUtmCampaign = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const utmCampaign = urlParams.get('utm_campaign')

    if (utmCampaign)
        localStorage.setItem('utm_campaign', utmCampaign)
}

// Función para obtener y almacenar el utm_term
const obtainUtmTerm = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const utmTerm = urlParams.get('utm_term')

    if (utmTerm)
        localStorage.setItem('utm_term', utmTerm)
}

// Función para obtener y almacenar el utm_content
const obtainUtmContent = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const utmContent = urlParams.get('utm_content')

    if (utmContent)
        localStorage.setItem('utm_content', utmContent)
}

// Put GCLID in the form
const populateGclid = () => {
    const gclid = localStorage.getItem('gclid')

    if (gclid) {
        return gclid;
    } else {
        return '';
    }
}

// Función para colocar el valor de utm_source en el formulario de Salesforce
const populateUtmSource = () => {
    const utmSource = localStorage.getItem('utm_source')

    if (utmSource) {
        return utmSource;
    } else {
        return '';
    }
}

// Función para colocar el valor de utm_medium en el formulario de Salesforce
const populateUtmMedium = () => {
    const utmMedium = localStorage.getItem('utm_medium')

    if (utmMedium) {
        return utmMedium
    } else {
        return '';
    }
}

// Función para colocar el valor de utm_campaign en el formulario de Salesforce
const populateUtmCampaign = () => {
    const utmCampaign = localStorage.getItem('utm_campaign')

    if (utmCampaign) {
        return utmCampaign
    } else {
        return '';
    }
}

// Función para colocar el valor de utm_term en el formulario de Salesforce
const populateUtmTerm = () => {
    const utmTerm = localStorage.getItem('utm_term')

    if (utmTerm) {
        return utmTerm;
    } else {
        return '';
    }
}

// Función para colocar el valor de utm_content en el formulario de Salesforce
const populateUtmContent = () => {
    const utmContent = localStorage.getItem('utm_content')

    if (utmContent) {
        return utmContent;
    } else {
        return '';
    }
}

export {
    obtainGclid,
    populateGclid,
    obtainUtmSource,
    obtainUtmMedium,
    obtainUtmCampaign,
    obtainUtmTerm,
    obtainUtmContent,
    populateUtmSource,
    populateUtmMedium,
    populateUtmCampaign,
    populateUtmTerm,
    populateUtmContent
}